export class PaginationInfo {
  pageNumber: number | undefined;
  pageSize?: number = 10;
}

export class Filter {
  fromDate: Date | undefined;
  toDate: Date | undefined;
  supplierIds: number[] | undefined;
}

export class GetSettlementRequestsBySupplierRequest {
  paginationInfo: PaginationInfo | undefined;
  filter: Filter | undefined;
}

export class GetSettlementRequestsBySupplierResponse {
  key: string | undefined;
  requestDate: Date | undefined;
  requestDate_Persian: string | undefined;
  settlementAmount: number | undefined;
  description: string | undefined;
  supplierUser: string | undefined;
  supplier: string | undefined;
  supplierIban: string | undefined;
  supplierId: number | undefined;
  supplierUserId: number | undefined;
  paymentHistoryItems: PaymentHistoryItems[] | undefined;
}

export class PaymentHistoryItems {
  referenceKey: string | undefined;
  customerName: string | undefined;
  customerNationalCode: string | undefined;
  customerMobileNumber: string | undefined;
  loanTemplateTitle: string | undefined;
  loanAmount: number | undefined;
  settlementAmount: number | undefined;
  assignedDate: Date | undefined;
  assignedDate_Persian: string | undefined;
  financialSupplierTitle: string | undefined;
  supplier: string | undefined;
  supplierUser: string | undefined;
  supplierUserMobile: string | undefined;
}
export class CreateNewPaymentSettlementRequest {
  settlementType: string | undefined;
  supplierSettlementRequestKeys: string[] | undefined;
  description: string[] | undefined;
}

export class GetPaymentSettlementResponse {
  key: string | undefined;
  creatorUser: string | undefined;
  finalizerUser: string | undefined;
  createDate: string | undefined | Date;
  createDate_Persian: string | undefined;
  finalizeDate: string | undefined | Date;
  finalizeDate_Persian: string | undefined;
  creatorDescription: string | undefined;
  settlementType: string | undefined;
  settlementTypeTitle: string | undefined;
  chequeSayadNumber: string | undefined;
  chequeSeri: string | undefined;
  chequeSerial: string | undefined;
  chequeDueDate: string | undefined | Date;
  chequeDueDate_Persian: string | undefined;
  onlineTransactionNumber: string | undefined;
  finalizerDescription: string | undefined;
  settlementAmount: number | undefined;
  seriSerial?: string | undefined;
}
export class PaymentSettlementKeyRequest {
  paymentSettlementKey: string | undefined;
}
export class FinalizePaymentSettlementRequest {
  paymentSettlementKey: string | undefined;
  chequeSayadNumber: string | undefined;
  description?: string | undefined;
}
export class GetPaymentSettlmentInfoResponse {
  creatorUserTitle: string | undefined;
  createPersianDate: string | undefined;
  finalizerUserTitle: string | undefined;
  finalizePersianDate: string | undefined;
  settlementTypeTitle: string | undefined;
  settlementType: string | undefined;
  settlementAmount: 0 | undefined;
  creatorDescription: string | undefined;
  finalizerDescription: string | undefined;
  chequeSayadNumber: string | undefined;
  chequeSeri: string | undefined;
  chequeSerial: string | undefined;
  chequeDuePersianDate: string | undefined;
  transactionPersianDate: string | undefined;
  transactionNumber: string | undefined;
  supplierPayments: GetPaymentRequestInfoResponse[] | undefined;
}
export class GetPaymentRequestInfoResponse {
  key: string | undefined;
  supplierId: number | undefined;
  supplierTitle: string | undefined;
  supplierLogo: string | undefined;
  supplierUserTitle: string | undefined;
  requestPersianDate: string | undefined;
  settlementAmount: number | undefined;
  supplierIban: string | undefined;
  description: string | undefined;
  loanRequests?: LoanRequests[] | undefined | any;
}

export class LoanRequests {
  referenceKey: string | undefined;
  customerTitle: string | undefined;
  customerMobile: string | undefined;
  loanTemplateTitle: string | undefined;
  loanAmount: number | undefined;
  settlementAmount: number | undefined;
  loanAssignPersianDate: string | undefined;
  financialSupplierTitle: string | undefined;
  supplierUserTitle: string | undefined;
  supplierUserMobile: string | undefined;
}
